<script>
  import { useSidebarOpen } from './SidebarContext.svelte';

  const open = useSidebarOpen();
</script>

<div class='sidebar-heading' class:open={$open}>
  <slot/>
</div>

<style lang='postcss'>
  .sidebar-heading {
    align-self: stretch;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: var(--spacing--xs);
    color: var(--color--grey-60);
    font: var(--font--outfit-12);
    margin: var(--spacing--s) var(--spacing--xs) 0 var(--spacing--xs);

    &.open {
      margin-left: 0;
      justify-content: start;
    }
  }
</style>
